export const UPDATE_TICKET_FILTERS = "UPDATE_TICKET_FILTERS";
export const FETCH_TICKETS = "FETCH_TICKETS";
export const FETCH_SUPPORTS = "FETCH_SUPPORTS";
export const SEND_SUPPORT = "SEND_SUPPORT";
